import { render } from "./ConfiguracaoInicialVendas.vue?vue&type=template&id=18433222&scoped=true&ts=true"
import script from "./ConfiguracaoInicialVendas.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialVendas.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialVendas.vue?vue&type=style&index=0&id=18433222&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18433222"]])

export default __exports__